<div class="w-full max-w-lg bg-white rounded shadow-lg p-0">
  <div class="bg-blue-500 text-white text-lg font-semibold px-6 py-4 rounded-t">Add to CA#</div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-6 flex flex-col gap-6">
    <!-- Progress indicator -->
    <div class="flex items-center justify-center gap-4 mb-6">
      <div class="flex items-center gap-2">
        <div class="size-6 rounded-full bg-green-500 flex items-center justify-center">
          <span class="text-white">✓</span>
        </div>
        <span class="text-gray-600">Authorization</span>
      </div>
      <div class="w-16 h-[2px] bg-gray-300"></div>
      <div class="flex items-center gap-2">
        <div class="size-6 rounded-full bg-blue-500 flex items-center justify-center">
          <span class="text-white">2</span>
        </div>
        <span class="text-gray-600">CA#</span>
      </div>
    </div>
    <!-- Form fields -->
    <div class="flex flex-col gap-2">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Search CA Number</mat-label>
        <input
          type="text"
          matInput
          [matAutocomplete]="auto"
          formControlName="caNumber"
          #caNumberInput
          (input)="onCaNumberInput(caNumberInput.value)"
          (focus)="onCaNumberFocus(caNumberInput.value)"
          autocomplete="off"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayCaNumber"
          (optionSelected)="onCaNumberSelected($event)"
        >
          <mat-option *ngFor="let ca of filteredCaNumbers; trackBy: trackById" [value]="ca">
            {{ ca.caNumber }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div *ngIf="caNumbersLoading() && selectedCaNumbersError()" class="text-red-600 text-sm">
      {{ errorText }}
    </div>
    <div class="flex justify-end gap-4 mt-4">
      <button
        mat-flat-button
        type="button"
        (click)="onCancel()"
        [disabled]="caNumbersLoading() || submitted()"
      >
        CANCEL
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="!bg-blue-600 !hover:bg-blue-700 !text-white font-semibold shadow-md min-w-[120px] flex items-center justify-center"
        [disabled]="caNumbersLoading()"
      >
        <ng-container *ngIf="caNumbersLoading() || submitted(); else addText">
          <mat-progress-spinner
            diameter="20"
            mode="indeterminate"
            color="accent"
            class="inline-block align-middle"
            [strokeWidth]="3"
          ></mat-progress-spinner>
        </ng-container>
        <ng-template #addText>ADD TO CA#</ng-template>
      </button>
    </div>
  </form>
</div>
